import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CustomParagraph from './CustomParagraph';
import CustomButton from './CustomButton';
import ContactSalesTeam from '../pages/landing/components/ContactSalesTeam';
import { ZoomlogiNewColorLogo } from '../assets/icons/icons';
import { CustomModalWithoutButton } from '.';

const Header: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const openContactTeamModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <header className={`header ${isSticky ? 'is-sticky' : ''}`}>
        <div className='container'>
          <div className='header-content'>
            <Link to='/' title='logo' className='header-logo'>
              <ZoomlogiNewColorLogo width={20} height={16} />
              <CustomParagraph
                text='Zoomlogi'
                color='#020922'
                fontSize={'16px'}
                fontWeight={'600'}
                lineHeight={'28px'}
                marginBottom={0}
              />
            </Link>

            <div className='header-btn'>
              <Link to='/login' className='btn btn-primary'>
                Login
              </Link>
              <CustomButton
                text='Contact sales'
                fontSize='14px'
                fontWeight='700'
                lineHeight='16px'
                bgColor='white'
                color='black'
                height='36px'
                width='118px'
                boxShadow='none'
                onClick={() => openContactTeamModal()}
              />
            </div>
          </div>
        </div>
      </header>
      <CustomModalWithoutButton
        modalTitle='Contact our sales team'
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalSize={500}
      >
        <ContactSalesTeam closeModal={closeModal} />
      </CustomModalWithoutButton>
    </>
  );
};

export default Header;
